export default __webpack_public_path__ + "static/media/jrc_logo_main.5cdb0698.png";